import { GeneralPropsType } from "@/common/types";
import { useRealtimeData } from "@/contexts/RealtimeData";
import getOverrideRateService from "@/services/getOverrideRateService";
import { CircularProgress } from "@nextui-org/react";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import styles from "./index.module.css";
interface TokenRateLifeTimePropsType extends GeneralPropsType {
  timeCircle?: number;
}
function TokenRateLifeTime({
  children,
  className,
  timeCircle = 3600
}: TokenRateLifeTimePropsType) {
  const {
    tokensRateState,
    setTokensRateState
  } = useRealtimeData();
  const [timePercent, setTimePercent] = useState(0);
  const remainTime = useRef(0);
  const step = 200;
  useEffect(() => {
    let ti: any;
    try {
      if (!tokensRateState?.updatedAt) return;
      const updatedTime = new Date(tokensRateState?.updatedAt)?.getTime();
      const nextTime = updatedTime + (tokensRateState?.secondsTrackingExchangeRate ?? timeCircle) * 1000;
      const currentTime = new Date()?.getTime();
      remainTime.current = nextTime - currentTime;
      ti = setInterval(() => {
        setTimePercent(100 - remainTime.current * 100 / ((tokensRateState?.secondsTrackingExchangeRate ?? timeCircle) * 1000));
        remainTime.current -= step;
        if (remainTime.current <= 0) {
          getOverrideRateService(data => {
            setTokensRateState((pre: any) => {
              return {
                ...pre,
                ...(data?.rateToken as any)
              };
            });
          });
          clearInterval(ti);
        }
      }, step);
    } catch (err) {
      console.log("🚀 ~ ConvertPage ~ err:", err);
    }
    return () => {
      clearInterval(ti);
    };
  }, [tokensRateState]);
  return <div className={clsx("size-4 flex items-center justify-center", styles.container, className)} data-sentry-component="TokenRateLifeTime" data-sentry-source-file="index.tsx">
            <CircularProgress value={timePercent} strokeWidth={4} color="secondary" classNames={{
      svg: "!size-4"
    }} data-sentry-element="CircularProgress" data-sentry-source-file="index.tsx" />
        </div>;
}
export default TokenRateLifeTime;